/**
 * @(#)2019/8/06.
 * Modal 模态框-用于弹出各种处理
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import YxModal from "./YxModal";
import PropTypes from "prop-types";

//prop 类型约束
YxModal.propTypes = {
  popupType: PropTypes.string,
  okText: PropTypes.node,
};
// 默认props
YxModal.defaultProps = {
  popupType: "modal", //弹窗类型，默认为模态框   modal/drawer
  okText: null,
};
export default YxModal;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxModal/index.js